import styled from "styled-components";
import { Modal } from "components/Modal";
export const VerificationModalContainer = styled(Modal)`
  .modal-content {
    padding: 0px;
    border: 0;

    .modal-body {
      margin-top: 0px;
      padding: 24px;

      .heading {
        .back-btn {
          cursor: pointer;
        }

        h2 {
          font-size: 16px;
          color: #181d27;
          font-family: "Geist", sans-serif;
          font-weight: 500;
          line-height: 24px;
          margin-bottom: 24px;
        }

        p {
          color: #535862;
          font-family: "Public Sans", sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          margin-bottom: 0px;
        }
      }

      .content-wrapper {
        margin-top: 20px;
      }
    }
  }
`;

export const VerificationUploadArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  border: 1px solid #e9eaeb;
  border-radius: 12px;
  padding: 16px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;

  &:hover {
    border-color: #3b82f6;
    background: #f9fafb;
  }
  .upload-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #d5d7da;
    color: #414651;
  }

  .upload-text {
    font-size: 14px;
    color: #535862;
    font-family: "Geist", sans-serif;
    font-weight: 400;
    line-height: 20px;
    margin-top: 12px;

    span {
      color: #1841dd;
      font-weight: 600;
    }
  }

  .sub-title {
    font-size: 12px;
    color: #535862;
    font-family: "Geist", sans-serif;
    font-weight: 400;
    line-height: 18px;
    margin-top: 4px;
    margin-bottom: 0;
  }
`;

export const FilePreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  margin-top: 20px;

  .file-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .file-icon {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      background: #fee4e2;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d92d20;
      font-weight: 600;
      font-size: 10px;
    }

    .file-details {
      display: flex;
      flex-direction: column;

      .file-name {
        color: #414651;
        font-size: 14px;
        font-weight: 500;
      }

      .file-size-status {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        color: #535862;

        .success-text {
          display: flex;
          align-items: center;
          gap: 4px;
        }
      }
    }
  }

  .actions {
    display: flex;
    gap: 8px;
  }

  .action-btn {
    cursor: pointer;
    color: #535862;
    transition: color 0.2s;

    &:hover {
      color: #181d27;
    }

    &.delete:hover {
      color: #d92d20;
    }
  }
`;

export const ProcessingStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;

  .spinner {
    margin-bottom: 24px;
    /* Add your spinner styles or use a component */
  }

  h3 {
    color: #181d27;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    color: #535862;
    font-size: 14px;
    text-align: center;
  }
`;

export const ResultStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;

    &.success {
      background: #dcfae6;
      color: #079455;
    }

    &.error {
      background: #fef3f2;
      color: #d92d20;
    }
  }

  h3 {
    color: #181d27;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    color: #535862;
    font-size: 14px;
    text-align: center;
    margin-bottom: 32px;
  }

  .action-buttons {
    display: flex;
    gap: 12px;
    width: 100%;

    button {
      flex: 1;
      padding: 10px;
      border-radius: 8px;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;

      &.cancel {
        background: #fff;
        border: 1px solid #d5d7da;
        color: #414651;
      }

      &.primary {
        background: #2258f1;
        border: 1px solid #2258f1;
        color: #fff;
        width: 100%;
      }
    }
  }
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-top: 16px;
  margin-top: 24px;

  .btn {
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #d5d7da;
    background: #fff;
    color: #414651;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    width: 50%;
  }

  .btn-submit {
    padding: 8px 24px;
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.12);
    background: #2258f1;
    color: white;
    width: 50%;
  }
`;

export const StyledParagraph = styled.p`
  margin-bottom: 6px !important;
  color: #535862;
  font-family: "Geist", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const RequirementsBox = styled.div`
  ul {
    margin: 0;
    padding-left: 1rem;
    list-style-type: disc;

    li {
      color: #181d27;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`;

export const FileListWrapper = styled.div`
  max-height: 200px;
  overflow-y: auto;
  margin-top: 20px;

  & > div {
    margin-top: 10px;
  }
`;
